export default "__VITE_PUBLIC_ASSET__f57c9c6b__"